/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'goal-fields.goal-followers.add-followers-title': 'フォロワーを追加',
  'goal-fields.goal-followers.title': 'フォロワー',
  'goal-fields.goal-links.add-parent-goal-title': '親ゴールを追加してください',
  'goal-fields.goal-links.edit-parent-goal-title': '親ゴールを編集',
  'goal-fields.goal-links.unlink-parent-goal-title': '親ゴールのリンクを解除',
  'goal-fields.goal-metrics.automatic-metric-title': 'サブゴールから',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': '開始:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'ターゲット:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    '進捗は {compass} によって自動入力されます。このゴールのメトリックは {compass} でのみ編集できます。',
  'goal-fields.goal-metrics.no-metrics-instructions': 'ゴール詳細ページに移動して、このフィールドを変更します',
  'goal-fields.goal-metrics.no-metrics-title': 'メトリックなし',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': '進捗状況',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'メトリックを含むサブゴールが接続されていません',
  'goal-fields.goal-metrics.title': '進捗',
  'goal-fields.goal-owner.title': '所有者',
  'goal-fields.goal-start-date.add-start-date-title': '開始日を追加',
  'goal-fields.goal-start-date.cancel-button': '保存',
  'goal-fields.goal-start-date.creation-date': 'このゴールは {creationDate}に作成されました',
  'goal-fields.goal-start-date.edit-start-date-label': 'ゴール開始日を編集',
  'goal-fields.goal-start-date.enter-start-date-title': '開始日を入力',
  'goal-fields.goal-start-date.open-calendar-label': 'カレンダーを開く',
  'goal-fields.goal-start-date.title': '開始日',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': '進行中',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'その他のステータス',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': '現在のステータスを選択してください',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    '目標と主な成果 (OKR) の実践に関心をお持ちですか?<link>OKR でゴールを使用する方法をご確認ください</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'ヘルプ リンク',
  'goal-fields.goal-status.archived': 'アーカイブ済み',
  'goal-fields.goal-status.at-risk': 'リスクあり',
  'goal-fields.goal-status.cancelled': 'キャンセル済み',
  'goal-fields.goal-status.completed': '完了 🎉',
  'goal-fields.goal-status.edit-status-lozenge': 'ステータスを編集',
  'goal-fields.goal-status.off-track': '遅延',
  'goal-fields.goal-status.on-track': '順調',
  'goal-fields.goal-status.paused': '一時停止中',
  'goal-fields.goal-status.pending': '保留中',
  'goal-fields.goal-status.title': 'ステータス',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'サブゴールを追加',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'サブゴールのリンクを解除',
  'goal-fields.goal-tags.add-tags-title': 'タグを追加する',
  'goal-fields.goal-tags.title': 'タグ',
  'goal-fields.goal-target-date.title': '期日',
  'goal-fields.goal-type.goal': 'ゴール',
  'goal-fields.goal-type.key-result': '主要な成果',
  'goal-fields.goal-type.objective': 'OKR 目標',
  'goal-fields.goal-type.title': 'タイプ',
  'goal-fields.parent-goal.title': '親ゴール',
  'goal-fields.sub-goals.title': 'サブゴール',
  'goal-fields.teams.add-teams-title': 'チームを追加',
  'goal-fields.teams.follow-team': 'チームをフォロー',
  'goal-fields.teams.remove-team': 'チームを削除',
  'goal-fields.teams.search-team-placeholder': 'チームを検索',
  'goal-fields.teams.show-more': 'さらに表示',
  'goal-fields.teams.title': 'チーム',
  'goal-fields.teams.verified-team-label': '検証済みのチーム',
  'goal-fields.teams.view-profile': 'プロファイルを表示',
  'goal-fields.use-goal-flags.generic-error-description': '問題が発生しました。しばらくしてから再度お試しください。',
  'goal-fields.use-goal-flags.generic-error-title': '問題が発生しました',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'ゴール所有者を変更できませんでした',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'タグを追加できませんでした',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'タグを作成できませんでした',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'タグを削除できませんでした',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title':
    'チームの追加中にエラーが発生しました。もう一度お試しください',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title':
    'チームの削除中にエラーが発生しました。もう一度お試しください',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': '親ゴールを変更できませんでした',
  'goal-fields.use-goal-flags.start-date-change-error-header': '開始日を変更できませんでした',
  'goal-fields.use-goal-flags.target-date-change-error-header': '目標日を変更できませんでした',
  'townsquare.goal-fields.tag': 'タグを削除',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, other {{usageCount,number} 箇所で使用されています}}',
};
